// extracted by mini-css-extract-plugin
export default {"tituloAssoolive":"OAzeite_tituloAssoolive__WEeGa","textoAssoolive":"OAzeite_textoAssoolive__BHyOJ"};